import { render, staticRenderFns } from "./TaskIndex.vue?vue&type=template&id=58087b2f&scoped=true&"
import script from "./TaskIndex.vue?vue&type=script&lang=js&"
export * from "./TaskIndex.vue?vue&type=script&lang=js&"
import style0 from "./TaskIndex.vue?vue&type=style&index=0&id=58087b2f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58087b2f",
  null
  
)

export default component.exports